import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaOrderLaundryReceptionTypeClothe} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {TypeClothe} from '../../../../../../model'
import {createReceptionByLaundry, updateReceptionByLaundry} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../../../components/UI/Select'
import {
  InputNumberDecimal,
  InputNumberWithSerialPort,
  InputTextArea,
} from '../../../../../../../../components/UI/Input'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../../../util/Constants'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getReceptionByLaundryList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: any
  addFunction?: (e: any) => void
}

const ModalAddRecepcion: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getReceptionByLaundryList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useLavanderia()
  const [typeFurniture, setTypeFurniture] = useState<TypeClothe[] | any>([])
  const [typeObservations, setTypeObservations] = useState<TypeClothe[] | any>([])
  const [loading, setLoading] = useState<boolean>(false)
  const methods = useForm<TypeClothe>({
    resolver: yupResolver(schemaOrderLaundryReceptionTypeClothe),
  })
  const {
    control,
    setValue,
    handleSubmit,
    register,
    formState: {errors},
  } = methods

  const [isAutomaticWeight, setIsAutomaticWeight] = useState<boolean>(true)
  const getTypeObservationsList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoObservacionLavanderia',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      setTypeObservations(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getTypeFurnitureList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoRopa',
      })
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.nombreCorto,
        label: master.nombreCorto,
      }))
      const getGenericClothe = mappedMaster.filter((item) => item.label === 'ROPA GENÉRICA')
      setValue('tipoRopa', getGenericClothe[0].value || '')
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  useEffect(() => {
    if (idPermission) {
      setValue('tipoRopa', detailpermission?.tipoRopa.trim())
      setValue('cantidad', detailpermission?.cantidad)
      setValue('peso', detailpermission?.peso)
      setValue('observaciones', detailpermission?.observaciones)
      setValue('tipoObservacion', detailpermission?.tipoObservacion)
      setValue('estado', detailpermission?.estado)
      // getPermissionByOptionList(detailpermission?.vistaPermisoId)
    }
  }, [idPermission])

  useEffect(() => {
    getTypeFurnitureList()
    getTypeObservationsList()
  }, [])

  const handleClose = () => {
    setShow(false)
    // reset()
    setIdPermissionList()
    setValue('tipoRopa', '')
    setValue('cantidad', '')
    setValue('peso', '')
    setValue('observaciones', '')
    setValue('estado', '')
    setValue('tipoObservacion', '')
  }

  const onSubmit = async (data: TypeClothe) => {
    setLoading(true)
    try {
      if (idPermission) {
        let obj = {
          ordenId: currentTabItem.idToEdit,
          detalle: {
            id: idPermission,
            ...data,
          },
        }

        const {data: res} = await updateReceptionByLaundry(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con exito')
          handleClose()
          getReceptionByLaundryList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      } else {
        let obj = {
          ordenId: currentTabItem.idToEdit,
          detalle: data,
        }

        const {data: res} = await createReceptionByLaundry(obj)
        if (!res.error) {
          ShowSnackBar('Se actualizó con exito')
          handleClose()
          getReceptionByLaundryList()
          //mostrar snackbar
        } else {
          ShowSnackBar(res.message, 'error')
        }
      }
      setLoading(false)
    } catch (error) {
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
      setLoading(false)
    }
  }

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {idPermission ? (
            <h5 className='modal-title'>Editar Ropa</h5>
          ) : (
            <h5 className='modal-title'>Agregar Ropa</h5>
          )}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <FormProvider {...methods}>
            <form>
              <div className='row'>
                <div className='mb-2 col-6'>
                  <label className='required'>Tipo de ropa</label>
                  <Select control={control} name='tipoRopa' data={typeFurniture} errors={errors} />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <label>Cantidad:</label>
                  <InputNumberDecimal
                    name='cantidad'
                    textPlaceholder='Escribe la cantidad'
                    register={register}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-6'>
                  <div className='d-flex justify-content-between align-items-center pe-6'>
                    <label className='required'>Peso KG:</label>
                    <div className='form-check form-switch form-check-custom form-check-solid'>
                      <label className='form-check-label me-2' htmlFor='switchPeso'>
                        Automático
                      </label>
                      <input
                        className='form-check-input h-20px w-30px'
                        type='checkbox'
                        checked={isAutomaticWeight}
                        defaultChecked={isAutomaticWeight}
                        onChange={() => setIsAutomaticWeight(!isAutomaticWeight)}
                        id='switchPeso'
                      />
                    </div>
                  </div>
                  <InputNumberWithSerialPort
                    name='peso'
                    textPlaceholder='Escribe el peso'
                    register={register}
                    errors={errors}
                    automatic={isAutomaticWeight}
                    onChangeValueWeight={(value) => setValue('peso', value)}
                  />
                </div>
                <div className='mb-2 col-6'>
                  <label>Tipo de Observación</label>
                  <Select
                    control={control}
                    name='tipoObservacion'
                    data={typeObservations}
                    errors={errors}
                  />
                </div>
                <div className='col-sm-12 col-lg-12'>
                  <label>Detalle de Observación:</label>
                  <InputTextArea
                    name='observaciones'
                    textPlaceholder='Escribe la observación'
                    register={register}
                    errors={errors}
                  />
                </div>
              </div>
              <div className='d-flex justify-content-center mb-3'>
                <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={handleSubmit(onSubmit)}
                  disabled={loading}
                >
                  Guardar
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddRecepcion}
